<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="row">
        <div class="col-12 mb-4">
            <v-card>
                <v-card-title>
                    {{$t('marchand.marchand_management')}}
                    <v-spacer></v-spacer>

                    <v-text-field
                            v-model="search"
                            append-icon="mdi-magnify"
                            label="Search"
                            single-line
                            hide-details
                    ></v-text-field>
                </v-card-title>
                <v-data-table
                        :headers="headers"
                        :items="marchands"
                        :loading="!marchands"
                        :search="search"
                        loading-text="Chargement en cours..."
                        sort-by="label"
                        class="elevation-0">

                    <template v-slot:item._file="{item}">
                        <a :href="item._file">{{getFileOriginalName(item._file)}}</a>
                    </template>

                    <template v-slot:item.country="{item}">
                        <country-flag :title="item.country ? item.country._name : ''" v-if="item.country" :country="item.country._code" size='normal'/>
                    </template>
                    <template v-slot:top>
                        <v-row>
                            <v-col cols="12" sm="4" class="ml-2">
                                <v-overflow-btn
                                        :items="drop_down_user_countries"
                                        label="Filtrer par pays"
                                        target="#dropdown-example"
                                        v-model="country_key"
                                        @change="filterMarchands('country')">
                                </v-overflow-btn>
                            </v-col>
                        </v-row>
                    </template>
                    <template v-slot:item._file="{item}">
                        <a :href="item._file" target="_blank">

                            <img :src="item._file" style="width: 70px;cursor: pointer;"  data-toggle="modal" data-target="#infos"/>
                        </a>
                    </template>
                    <template v-slot:item._web_site="{item}">
                        <a :href="'../../'+item._web_site" target="_blank">
                            {{item._web_site}}
                        </a>
                    </template>
                    <template v-slot:item._user_id="{item}">
                        <router-link :to="'/users/'+item._user_id._id">{{item._user_id._email}}</router-link>
                    </template>
                    <template v-slot:item._usermeanspaiement="{item}">
                        <div v-if="item._usermeanspaiement.length===0">
                            <div>
                                N/A
                            </div>
                        </div>
                        <div v-else>
                            <div   style="padding-left: 2%">
                                <v-row>
                                    <span v-for="user_means in item._usermeanspaiement" :key="user_means._file">
                                         <img style="height: 20px; width: 20px; border-radius: 100%;margin-left: -2.5%;border: 2px solid #29B3A6" :title="user_means._means_paiement._name" :src="'../'+user_means._means_paiement._file" alt=""/>
                                    </span>

                                </v-row>

                            </div>
                        </div>

                    </template>

                    <template  v-slot:item._categorie_id="{item}"  >
                        <div  v-if="item._categorie_id">
                            {{item._categorie_id._description}}

                        </div>
                        <div v-else>Null</div>
                    </template>
                    <template v-slot:item._state_id="{item}">
                        <div  v-if="item._state_id">
                            <v-overflow-btn
                                    dense
                                    :items="drop_down_state_marchands"
                                    :label="item._state_id._name"
                                    target="#dropdown-example"
                                    v-model="item._state_id" @change="categorieChanged(item)">
                            </v-overflow-btn>
                        </div>
                        <div v-else>
                            <v-overflow-btn
                                    dense
                                    :items="drop_down_state_marchands"
                                    label="Null"
                                    target="#dropdown-example"
                                    v-model="item._state_id">
                            </v-overflow-btn>
                        </div>

                    </template>

                    <template v-slot:item._created_at="{item}">
                        {{ new Date(item._created_at).toLocaleDateString()}}
                    </template>

                    <template v-slot:item.actions="{ item }">
                      <div style="text-align:  right">
                          <v-menu
                                  key="text"
                                  rounded="b-xl">
                              <template v-slot:activator="{ attrs, on }">

                                      <v-icon
                                      class="black--text "
                                      v-bind="attrs"
                                      v-on="on">mdi-dots-vertical</v-icon>

                              </template>
                                <v-list>
                                    <v-list-item>
                                        <v-list-item-icon>
                                            <v-icon color="#29B3A6">mdi-toolbox-outline</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                <router-link style="text-decoration: none" :to="{name:'services.administrator',params: { user_id: item._user_id._id,marchand_id: item._id}}">
                                                    {{$t('menus.services')}}
                                                </router-link>
                                            </v-list-item-title>
                                        </v-list-item-content>

                                    </v-list-item>
                                    <v-list-item  >
                                        <v-list-item-icon>
                                            <v-icon color="#29B3A6">mdi-eye</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>

                                            <v-list-item-title >
                                                <router-link  style="text-decoration: none"  :to="{name:'marchand.details',params: { id: item._id}}">
                                                    Détails
                                                </router-link>
                                            </v-list-item-title>
                                        </v-list-item-content>

                                    </v-list-item>

                                    <v-list-item>
                                        <v-list-item-icon>
                                            <v-icon color="#29B3A6">mdi-call-split</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>

                                        <v-list-item-title>

                                            <router-link style="text-decoration: none"  :to="{name:'transactionsetting',params: { id: item._id}}">
                                                {{$t('menus.taux_echange')}}
                                            </router-link>
                                        </v-list-item-title>
                                        </v-list-item-content>

                                    </v-list-item>
                                    <v-list-item>
                                        <v-list-item-icon>
                                            <v-icon color="#29B3A6">mdi-check-decagram</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>

                                        <v-list-item-title>

                                            <router-link style="text-decoration: none"
                                            :to="{name:'marchandmeansconfirmation',params: { id: item._id}}">
                                                {{$t('menus.usersmeanspaiementconfirmation')}}
                                            </router-link>
                                        </v-list-item-title>
                                        </v-list-item-content>

                                    </v-list-item>
                                   
                                </v-list>
                            </v-menu>
                        </div>

                    </template>
                    <template v-slot:item.status="{ item }">
                        <v-switch @click="valideItem(item)" color="primary" :input-value="(item._statut)?'true':''"></v-switch>
                    </template>
                    <template v-slot:no-data>
                        <span>{{$t('marchand.no_marchand_found')}}</span>
                    </template>
                </v-data-table>
            </v-card>
            <customsnackbar :snackbar="customSnack.snackbar"
                            :text="customSnack.text"
                            :snackcolor="customSnack.snackcolor" :snackbBtnColor="customSnack.snackbBtnColor"
                            :snacktimeout="customSnack.snacktimeout" > </customsnackbar>
        </div>
    </div>
</template>


<script>
    import {mapState} from "vuex";
    import * as Swal from "sweetalert2";
    import helpers from "../../mixins/helpers";


    export default {
        name: "ListMarchand",
        mixins:[helpers(this)],

        data () {
            return {
                picker: new Date().toISOString().substr(0, 10),
                submitting:false,
                valid:true,
                country_key:'',
                lazy:false,
                errors:{},
                search: '',
                customSnack:{
                    snackbar: false,
                    text: "",
                    snackcolor:"black",
                    snackbBtnColor:"white",
                    snacktimeout:2000
                },
                dialog: '',
                index:0,
                id:undefined,
                date_issue: null,
                date_expired:null,
                menu: false,
                menus: false,
                headers: [
                    {text:  'Moyen de paiement', value: '_usermeanspaiement'},
                    {text:  this.$t('marchand.user'), value: '_user_id'},
                    {text: 'Pays', value: 'country'},
                    {text:  this.$t('marchand.site_web'), value: '_web_site'},
                    {text:  this.$t('marchand.company'), value: '_company'},
                    {text:  this.$t('marchand.etat'), value: '_state_id'},
                    { text:  '', value: 'actions', sortable: false },

                ],
                editedIndex: -1,
                editedItem: {
                    _num: '',
                    _type: '',
                    _file: '',
                    country: '',
                    _date_issue: '',
                    _date_expired: '',
                    _place_establishment: '',
                    _code: '',
                    _valide: '',
                    _created_at: 0,
                    _id:''
                },
                defaultItem: {
                    _type: '',
                    _num: '',
                    _file: '',
                    country:'',
                    _date_issue: '',
                    _date_expired: '',
                    _place_establishment: '',
                    _code: '',
                    _valide: '',
                    _created_at: 0,
                    _id:''
                },
                fileRules: [
                    v => !!v ||  this.$t('file_required'),
                ],
                typeRules: [
                    v => !!v ||  this.$t('type_required'),
                ],
                numRules: [
                    v => !!v ||  this.$t('number_required'),
                ],

                codeRules: [
                    v => !!v ||  this.$t('code_required'),
                ],
            }
        },
        computed: {
            formTitle () {
                return this.editedIndex === -1 ? this.$t('Nouveau document') : this.$t('Modifier document')
            },
            ...mapState('marchands/',['marchands']),
            ...mapState('state_marchands/',['state_marchands']),
            ...mapState('user_means_paiements/',['user_means_paiements']),
            ...mapState('countries/', ['countries']),
            drop_down_state_marchands: function(){
                let arr = [];
                this.state_marchands.forEach((state_marchand)=>{
                    arr.push({text:state_marchand._name,value:state_marchand._id})
                });
                return arr;
            },
            drop_down_user_countries: function(){
                let arr = [{text:"Tous les marchands",value:-1}];

                if (this.countries){
                    this.countries.forEach((country)=>{
                        arr.push({text:country._name,value:country._id})
                    });
                }

                return arr;
            },
        },
        mounted(){
            this.$store.dispatch('marchands/getMarchand').then(response=>{
                window.console.log('documents',response)
            });

            this.$store.dispatch('state_marchands/getState_Marchand').then(response=>{
                window.console.log('state_marchands',response)
            });
            this.$store.dispatch('countries/getCountries');

        },
        watch: {
            dialog (val) {
                val || this.close()
            },
            menu (val) {
                val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
            },
        },
        methods: {
            initialize () {
                this.langues = [
                    {
                        name:'Bénin',
                        code_iso_alpha_2:'BJ',
                        code_iso_alpha_3:'BEN',
                        code_iso_numerique:204
                    }
                ]
            },
            categorieChanged(item){
                let VueBox=this;
                Swal.fire({
                    icon: 'warning',
                    timerProgressBar: false,
                    text:   this.$t('marchand.change_etat'),
                    confirmButtonText:"Oui",
                    cancelButtonText: "Non",
                    showCancelButton: true,
                    confirmButtonColor:'#29B3A6'

                }).then(result => {
                    if (result.value) {
                        this.$store.dispatch('marchands/etatMarchand', {id:item._id,state:item._state_id}).then((result) => {
                            Swal.fire({
                                icon: 'success',
                                timer: 3000,
                                timerProgressBar: false,
                                text: this.$t(result.message),
                                position: 'top-end',
                                showConfirmButton: false
                            })
                        });
                        VueBox.toast('success',this.$t(result.message));

                    }
                })
            },
            filterMarchands(criteria){

                if (criteria==="role")
                    this.$store.dispatch('users/filterUsersByRole', this.role_key).then(() => {});
                else
                    this.$store.dispatch('marchands/filterMarchandsByCountry', this.country_key).then(() => {});
            },
            valideItem (item) {
                let VueBox=this;
                let message = (item._valide)?'Vous êtes sûr de vouloir rejeté les informations  ?':'Vous êtes sûr de vouloir validé ces informations ?';
                Swal.fire({
                    icon: 'warning',
                    timerProgressBar: false,
                    text: this.$t(message),
                    confirmButtonText:"Oui",
                    cancelButtonText: "Non",
                    showCancelButton: true,
                    confirmButtonColor:'#29B3A6'

                }).then(result => {
                    if (result.value) {
                        this.$store.dispatch('marchands/validMarchand', item._id).then((result) => {
                            Swal.fire({
                                icon: 'success',
                                timer: 3000,
                                timerProgressBar: false,
                                text: this.$t(result.message),
                                position: 'top-end',
                                showConfirmButton: false
                            });
                            VueBox.toast('success',this.$t(result.message));

                        })
                    }
                })
            },
           /* valideItem (item) {
                let VueBox = this;
                let message = (item._active)?this.$t('marchand.invalid_info'):this.$t('marchand.valid_info');
                let action = (item._active)?'marchand.deactivate':'marchand.activate';

                if (item._active){
                    Swal.fire({
                        title:this.$t('enter_reason') ,
                        input: 'textarea',
                        inputAttributes: {
                            autocapitalize: 'off'
                        },
                        showCancelButton: true,
                        confirmButtonText:  this.$t(action),
                        cancelButtonText: this.$t('cancel'),
                        cancelButtonColor:"#CCC",
                        confirmButtonColor:'#29B3A6',
                        showLoaderOnConfirm: true,
                        preConfirm: (reason) => {
                            let data = {reason:reason,id: item._id}
                            return this.$store.dispatch('marchands/validMarchand',data).then((result) => {
                                if (result.error) {
                                    Swal.showValidationMessage(
                                        VueBox.$t(result.message)
                                    )
                                }
                                return result;

                            })

                        },
                        allowOutsideClick: () => !Swal.isLoading()
                    }).then((result) => {
                        if (result.value) {
                            Swal.fire({
                                text: VueBox.$t(result.value.message),
                            })
                        }
                    })
                }else{
                    Swal.fire({
                        icon: 'warning',
                        timerProgressBar: false,
                        text: this.$t(message),
                        confirmButtonText:  this.$t(action),
                        cancelButtonText: this.$t('marchand.deactivate'),
                        showCancelButton: true,
                        cancelButtonColor:"#CCC",
                        confirmButtonColor:'#29B3A6'
                    }).then(result => {
                        if (result.value) {
                            this.$store.dispatch('marchands/validMarchand',{id:item._id,reason:''}).then(() => {
                                if (result.error) {
                                    Swal.fire({
                                        icon: 'error',
                                        timer: 3000,
                                        timerProgressBar: false,
                                        text: this.$t(result.message),
                                        showConfirmButton: true
                                    })
                                }
                            })
                        }
                    })
                }





            },*/

            editItem (item) {
                this.editedIndex = this.documents.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.dialog = true;
                this.id = item._id;
            },


            saves (date) {
                this.$refs.menu.save(date)
            },
            close () {
                this.dialog = false;
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                });
                this.$refs.form.reset()
            },


            validate () {
                this.$refs.form.validate()
            },
            reset () {
                this.$refs.form.reset()
            },
            checkisDashboard(){
                this.$emit('checkisDashboard',true);
            },
            fileChange() {
                console.log( this.$refs);
                this.editedItem._file = this.$refs.file.files[0];
            },
            getFileOriginalName(file){
                return file.substr(file.lastIndexOf('/')+1)
            },
        },
        created() {
            this.checkisDashboard();
            this.initialize()
        },
    }
</script>

<style scoped>
td{
    padding: unset !important;
}
</style>
